import { Accordion } from '../../../../../../components/general/accordion';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import { Grid } from '@mui/material';
import FieldText from '../../../../../../components/general/fields/fieldText';
import { PqrClosingProps } from '../props';
import { usePqrComplianceTerms } from './hook';

export const PqrComplianceTerms = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrComplianceTerms(closing);

    return (
        <Accordion
            title="CUMPLIMIENTO DE TÉRMINOS"
            icon={<SentimentNeutralIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} md={6}>
                    <FieldText
                        label="Cumplimiento de términos"
                        name="complianceTerms"
                        size="small"
                        value={formik.values.complianceTerms}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
